import * as React from 'react';

import ReportMetadataList from '../../components/ReportMetadataList';

import useDeleteCabinEventDraft from '../../core/api/hooks/cabin-event/useDeleteCabinEventDraft';

import useGetReportViewData from '../../core/hooks/useGetReportViewData';
import { DeleteRequest, EventFormStatus, ReportType } from '../../core/api/clients';
import useGetEventReportsByType from '../../core/api/hooks/event-report/useGetEventReportsByType';

function CabinEventDraftsAndSubmissions() {
  const { data: drafts, refetch: refetchDrafts } = useGetEventReportsByType({
    reportType: ReportType.CabinEventReport,
    hours: 0,
    statuses: [EventFormStatus.Draft],
    isOwner: true,
  });
  const { data: submissions } = useGetEventReportsByType({
    reportType: ReportType.CabinEventReport,
    hours: 0,
    statuses: [EventFormStatus.Submitted],
    isOwner: true,
  });
  const { mutate: deleteCabinEventDraft } = useDeleteCabinEventDraft();

  const reportViewData = useGetReportViewData(drafts || [], submissions || []);

  const handleDeleteRequest = (id: number) => {
    const request:DeleteRequest = { id };
    deleteCabinEventDraft(request, {
      onSuccess: () => {
        refetchDrafts();
      },
    });
  };

  return (
    <ReportMetadataList
      reports={reportViewData}
      handleDeleteRequest={handleDeleteRequest}
      uriSlug="cabin-event"
    />
  );
}

export default CabinEventDraftsAndSubmissions;
